const scrollParentOf = (el: HTMLElement): HTMLElement | null => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node)
    if (overflowY === "auto" || overflowY === "scroll") return node
  }
  return document.scrollingElement as HTMLElement | null
}

/**
 * Holds `el` where it sits in the viewport for `ms`, by scrolling its scroll parent as the layout
 * above it animates (an accordion folding the card before it). Stops as soon as the user scrolls.
 */
export const keepInPlace = (el: HTMLElement, ms: number) => {
  const scroller = scrollParentOf(el)
  if (!scroller) return
  const startTop = el.getBoundingClientRect().top
  const end = performance.now() + ms
  let cancelled = false
  const cancel = () => {
    cancelled = true
  }
  scroller.addEventListener("wheel", cancel, { passive: true })
  scroller.addEventListener("touchmove", cancel, { passive: true })
  const step = () => {
    if (!cancelled) scroller.scrollTop += el.getBoundingClientRect().top - startTop
    if (!cancelled && performance.now() < end) {
      requestAnimationFrame(step)
      return
    }
    scroller.removeEventListener("wheel", cancel)
    scroller.removeEventListener("touchmove", cancel)
  }
  requestAnimationFrame(step)
}
